import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appDynamicDateInput]',
})
export class DynamicDateInputDirective {
  private element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
  }

  @HostListener('focus')
  handleFocus(): void {
    this.element.nativeElement.type = 'date';
  }

  @HostListener('blur')
  handleBlur(): void {
    if (this.element.nativeElement.value === '') {
      this.element.nativeElement.type = 'text';
    }
  }
}
